import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { PROVISION_CURRENT_USER } from '@neo.tax/shared/graphql/documents.graphql';
import { ProvisionCurrentUserMutation, ProvisionCurrentUserMutationVariables } from '@neo.tax/shared/graphql/types';

/**
 * Provisioning for the SSO sign-in buttons: after a successful Firebase popup, creates the DB user via
 * the token-verified provisionCurrentUser mutation (the Apollo auth link attaches the freshly
 * authenticated session's ID token, from which the server derives email/uid/provider). Returns a stable
 * callback to hand to startOAuth.
 */
export const useProvisionCurrentUser = (): (() => Promise<void>) => {
  const [provisionCurrentUser] = useMutation<ProvisionCurrentUserMutation, ProvisionCurrentUserMutationVariables>(
    PROVISION_CURRENT_USER,
  );
  return useCallback(async (): Promise<void> => {
    await provisionCurrentUser();
  }, [provisionCurrentUser]);
};
